import { Link } from 'react-router-dom'
import { Logo } from '../components/shell/Logo'

export function LaunchPausedPage() {
  return <main className="flex min-h-screen items-center justify-center bg-paper-page px-5 py-12">
    <section className="w-full max-w-lg rounded-card border border-line-soft bg-paper-surface p-6 shadow-card sm:p-8">
      <Logo insetColor="#fffdf8" />
      <h1 className="mt-6 font-serif text-[28px] font-medium leading-tight text-ink">Public launch is paused</h1>
      <p className="mt-3 text-sm leading-relaxed text-ink-muted">New family registration and community participation are paused.</p>
      <p className="mt-3 text-sm leading-relaxed text-ink-muted">Existing account holders can still sign in, recover their password, or confirm their email.</p>
      <nav aria-label="Account access" className="mt-6 flex flex-wrap gap-x-5 gap-y-3 text-sm text-terra-deep">
        <Link to="/login" className="underline underline-offset-4">Sign in</Link>
        <Link to="/forgot-password" className="underline underline-offset-4">Recover password</Link>
        <Link to="/confirm-email" className="underline underline-offset-4">Confirm email</Link>
        <Link to="/verification" className="underline underline-offset-4">Manage existing account</Link>
      </nav>
    </section>
  </main>
}
